module.exports = __webpack_public_path__ + "img/team-updates.ded6efae.png";